module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("TOOLS")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-desktop"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Dashboard")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/makers"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-badge"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Makers")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/series"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-badge"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Model Series")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/types"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-badge"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Types")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/cars"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-badge"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Cars")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/variants"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-id-badge"
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Variants")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9b7e344"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarMenu.vue
// module id = 1477
// module chunks = 1